import { environment } from '../environments/environment';

export const TOKEN_ICON_PLACEHOLDER = '/assets/icons/token.png';

// logoURI is either a file name (resolved against `urls.tokenIcons`) or an absolute URL.
export function tokenIconUrl(logoURI?: string): string {
  if (!logoURI) {
    return TOKEN_ICON_PLACEHOLDER;
  }
  if (/^https?:\/\//i.test(logoURI)) {
    return logoURI;
  }
  return `${environment.urls.tokenIcons}/${logoURI}`;
}

export function tokenIconFallback(event: Event): void {
  const img = event.target as HTMLImageElement;
  if (!img.src.endsWith(TOKEN_ICON_PLACEHOLDER)) {
    img.src = TOKEN_ICON_PLACEHOLDER;
  }
}
